export default "__VITE_ASSET__Bby1UU07__"